var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancellation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1832_14415",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1832_14415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 70.8335L50 55.8335L65 70.8335L70.8333 65.0002L55.8333 50.0002L70.8333 35.0002L65 29.1668L50 44.1668L35 29.1668L29.1666 35.0002L44.1666 50.0002L29.1666 65.0002L35 70.8335ZM50 91.6668C44.2361 91.6668 38.8194 90.5731 33.75 88.3856C28.6805 86.1981 24.2708 83.2293 20.5208 79.4793C16.7708 75.7293 13.8021 71.3196 11.6146 66.2502C9.42706 61.1807 8.33331 55.764 8.33331 50.0002C8.33331 44.2363 9.42706 38.8196 11.6146 33.7502C13.8021 28.6807 16.7708 24.271 20.5208 20.521C24.2708 16.771 28.6805 13.8022 33.75 11.6147C38.8194 9.42725 44.2361 8.3335 50 8.3335C55.7639 8.3335 61.1805 9.42725 66.25 11.6147C71.3194 13.8022 75.7291 16.771 79.4791 20.521C83.2291 24.271 86.1979 28.6807 88.3854 33.7502C90.5729 38.8196 91.6666 44.2363 91.6666 50.0002C91.6666 55.764 90.5729 61.1807 88.3854 66.2502C86.1979 71.3196 83.2291 75.7293 79.4791 79.4793C75.7291 83.2293 71.3194 86.1981 66.25 88.3856C61.1805 90.5731 55.7639 91.6668 50 91.6668ZM50 83.3335C59.3055 83.3335 67.1875 80.1043 73.6458 73.646C80.1041 67.1877 83.3333 59.3057 83.3333 50.0002C83.3333 40.6946 80.1041 32.8127 73.6458 26.3543C67.1875 19.896 59.3055 16.6668 50 16.6668C40.6944 16.6668 32.8125 19.896 26.3541 26.3543C19.8958 32.8127 16.6666 40.6946 16.6666 50.0002C16.6666 59.3057 19.8958 67.1877 26.3541 73.646C32.8125 80.1043 40.6944 83.3335 50 83.3335Z",
    fill: "#002E40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancellation);
export default __webpack_public_path__ + "static/media/Cancellation.3abae3c4bac945e3afd4035f1a01ccce.svg";
export { ForwardRef as ReactComponent };